import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color:'#2b3990',
    '&:hover':{
      background:'#2b3990',
      color: '#fff'
    }
  },
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 12,
    fontWeight: 'normal',
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
}));
